export enum UserSecurityRoles {
	MarketShareUserRoleCode = 'MARKET_SHARE_USER',
	MarketShareAdminRoleCode = 'MARKET_SHARE_ADMIN',
	ServiceShareUserRoleCode = 'SERVICE_SHARE_USER',
	ServiceShareAdminRoleCode = 'SERVICE_SHARE_ADMIN',
	Undefined = 'Undefined'
}

export enum ApplicationSections {
	ManualInput = 'manualInput',
	ServiceShareInput = 'serviceShareInput',
	PeriodInputStatus = 'periodInputStatus',
	Administration = 'administration'
}

export interface UserRoleSections {
	userRole: UserSecurityRoles;
	applicationSections: ApplicationSections[];
}

export interface IUserRolesSectionsAssigned{
    marketShareUserSections: UserRoleSections;
    marketShareAdminSections: UserRoleSections;
    serviceShareUserSections: UserRoleSections;
    serviceShareAdminSections: UserRoleSections;
}

export const UserRolesSectionsAssigned: IUserRolesSectionsAssigned = {
	marketShareUserSections: {
		userRole: UserSecurityRoles.MarketShareUserRoleCode,
		applicationSections: [ApplicationSections.ManualInput],
	},
	marketShareAdminSections: {
		userRole: UserSecurityRoles.MarketShareAdminRoleCode,
		applicationSections: [
			ApplicationSections.ManualInput,
			ApplicationSections.ServiceShareInput,
			ApplicationSections.PeriodInputStatus,
			ApplicationSections.Administration,
		],
	},
    serviceShareUserSections: {
        userRole: UserSecurityRoles.ServiceShareUserRoleCode,
		applicationSections: [ApplicationSections.ServiceShareInput],
    },
    serviceShareAdminSections: {
		userRole: UserSecurityRoles.ServiceShareAdminRoleCode,
		applicationSections: [
			ApplicationSections.ManualInput,
			ApplicationSections.ServiceShareInput,
			ApplicationSections.PeriodInputStatus,
			ApplicationSections.Administration,
		],
	},
};
